<div class="box-modal">
  <div class="modal" #modal>
    <div class="wrapper">
      <div class="btn-cerrar" (click)="cerrarModal()" #element>
        <img src="./assets/img/ico_cerrar_base.svg" />
        <!-- <app-icon [Path]="'./assets/img/ico_cerrar_base.svg'"></app-icon> -->
      </div>
      <div class="head" #element>
        <div class="icono" *ngIf="icoSrc">
          <!-- <app-icon [Path]="icoSrc"></app-icon> -->
          <img [src]="icoSrc" />
        </div>
        <h3>{{tituloModal}}</h3>
      </div>
      <div class="body" #element>
        <!-- <ng-content select="[mensaje-modal]"></ng-content> -->
         <div [innerHTML]="parrafoModal"></div>
      </div>
      <div class="foo" #element>
        <div *ngIf="foo">
          <div [innerHTML]="foo"></div>
        </div>
      </div>
    </div>
    
  </div>
</div>